import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { pinia } from "./store/pinia"
// 额外引入图标库
import ArcoVueIcon from '@arco-design/web-vue/es/icon';
import '@arco-design/web-vue/dist/arco.css';
// 引入全局样式文件
import "./assets/css/arco.scss"
// 二次封装的arco组件
import { registerComponents } from "./components/customArco/index.js";
import "@/utils/autoUpdate.js"
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
// 自定义指令
import customDirective from "@/utils/directive.js";
// 全局i18n
import i18n from "@/i18n/index.js";

import { initI18n } from './i18n/languageservice.js';

dayjs.extend(isoWeek);

// 创建app
const app = createApp(App);
app.use(pinia);
app.use(router);
app.use(ArcoVueIcon);
initI18n(i18n);
app.use(i18n);
// initI18n(i18n).then(() => {
//     app.use(i18n);
//     app.mount('#app')
// }).catch(error => {
//     console.error('Application initialization failed:', error);
// });

registerComponents(app);

// 自定义指令
customDirective(app);


// filter
import * as filter from '@/utils/filters.js';
app.config.globalProperties.$filters = filter;
// utils
import { getHisCode, TaskQueue } from "@/utils/util.js";
const taskQueue = new TaskQueue();
app.config.globalProperties.getHisCode = function () {
    return taskQueue.add(getHisCode, ...arguments);
};
// socket
import Socket from "@/utils/webSocket.js";
app.config.globalProperties.socketClient = new Socket();
// signalr
import Signalr from "@/utils/signalr.js";
app.config.globalProperties.signalrClient = new Signalr();

app.mount('#app')